import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { CookieService } from "ngx-cookie-service";
import { CompanyService } from "src/app/app/company/company.service";
import { CountTranslationValues } from "src/app/app/_component/pagination-client-side/count-translation";

@Component({
  selector: "app-entry-view",
  templateUrl: "./entry-view.component.html",
  styleUrls: [
    "./entry-view.component.scss",
    "./../../../_styles/ion-grid-content-table.scss",
  ],
})
export class EntryViewComponent implements OnInit {
  constructor(
    public companyServ: CompanyService,
    private translateService: TranslateService,
    private cookieService: CookieService
  ) {}

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  mobile = false;
  timeDifference: number;
  timeStamp: string;
  showTimeStampPermamently = true;
  listOfClickedElements: any = [];

  ngOnInit() {
    if (this.cookieService.get("clickedElements")) {
      this.listOfClickedElements = this.cookieService
        .get("clickedElements")
        .split(",");

      this.listOfClickedElements.filter((el) => {
        if (el === this.row.id.toString()) {
          this.showTimeStampPermamently = false;
        }
      });
    }

    const enterTime = new Date(this.row.date).getTime();

    let currentTime = new Date().getTime();
    if (currentTime > enterTime && enterTime + 3600000 > currentTime) {
      this.timeStamp = this.minutesAgo(this.row.date);
    }

    setInterval(() => {
      currentTime = new Date().getTime();
      if (currentTime > enterTime && enterTime + 3600000 > currentTime) {
        this.timeStamp = this.minutesAgo(this.row.date);
      } else {
        this.timeStamp = null;
      }
    }, 5000);
  }

  onHideTimeStamp(event) {
    event.preventDefault();
    event.stopPropagation();

    let clickedElements = this.cookieService.get("clickedElements")
      ? this.cookieService.get("clickedElements").split(",")
      : [];

    this.showTimeStampPermamently = false;

    clickedElements.push(this.row.id.toString());

    this.cookieService.set(
      "clickedElements",
      JSON.parse("[" + clickedElements + "]"),
      1
    );
  }

  minutesAgo(value: any): any {
    let translateKey = "MINUTE_";

    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);
      const minutes = Math.floor(seconds / 60);

      if (seconds < 61) {
        return this.translateService.instant("JUST_NOW");
      } else {
        return minutes + " " + this.translateService.instant("MIN");
      }
    }
  }
}
